export const getSectionLabel = (fieldLabel: string, count: number) =>
  `${fieldLabel}${count ? ` (${count})` : ''}`;
